import i18n from "i18next";

export const CASH_BOX_DOCUMENT_TYPE_KP = 'kp';
export const CASH_BOX_DOCUMENT_TYPE_KW = 'kw';
export const STORAGE_DOCUMENT_TYPE = 'storage';
export const REPAIR_ORDER_TYPE = 'repairOrder';
export const SALE_DOCUMENT_TYPE_INVOICE = 'invoice';
export const SALE_DOCUMENT_TYPE_VAT_MARGIN = 'vatMargin';
export const SALE_DOCUMENT_TYPE_RECEIPT_FISCAL = 'receiptFiscal';
export const SALE_DOCUMENT_TYPE_CORRECTION_INVOICE = 'correctionInvoice';
export const SALE_DOCUMENT_TYPE_CORRECTION_RECEIPT_FISCAL = 'correctionReceiptFiscal';
export const SALE_DOCUMENT_TYPE_ADVANCE_INVOICE = 'advanceInvoice';
export const SALE_DOCUMENT_TYPE_FINAL_INVOICE = 'finalInvoice';
export const PRO_FORMA_DOCUMENT_TYPE = 'proForma';
export const WAREHOUSE_DOCUMENT_TYPE_WZ = 'wz';
export const WAREHOUSE_DOCUMENT_TYPE_ZWZ = 'zwz';
export const WAREHOUSE_DOCUMENT_TYPE_RW = 'rw';
export const WAREHOUSE_DOCUMENT_TYPE_PZ = 'pz';
export const WAREHOUSE_DOCUMENT_TYPE_ZPZ = 'zpz';
export const WAREHOUSE_DOCUMENT_TYPE_PW = 'pw';
export const WAREHOUSE_DOCUMENT_TYPE_R = 'r';
export const WAREHOUSE_DOCUMENT_INVENTORY_TYPE = 'inventory';
export const STORAGE_DEFAULT_DOCUMENT_TYPE = 'default';
export const STORAGE_DEFAULT_DOCUMENT_TYPE_NAME = 'ogolna';
export const STORAGE_TIRE_DOCUMENT_TYPE = 'tire';
export const STORAGE_TIRE_DOCUMENT_TYPE_NAME = 'opony';
export const STORAGE_SCOOTER_DOCUMENT_TYPE = 'scooter';
export const STORAGE_SCOOTER_DOCUMENT_TYPE_NAME = 'hulajnogi';
export const QUOTATION_TYPE = 'quotation';

export const SALE_DOCUMENT_TYPE_CORRECTION_TYPE_HEAD = 1;
export const SALE_DOCUMENT_TYPE_CORRECTION_TYPE_ITEMS = 2;

export const getWarehouseDocumentTypes = () => {
  return [
    WAREHOUSE_DOCUMENT_TYPE_WZ,
    WAREHOUSE_DOCUMENT_TYPE_ZWZ,
    WAREHOUSE_DOCUMENT_TYPE_RW,
    WAREHOUSE_DOCUMENT_TYPE_PZ,
    WAREHOUSE_DOCUMENT_TYPE_ZPZ,
    WAREHOUSE_DOCUMENT_TYPE_PW,
    WAREHOUSE_DOCUMENT_TYPE_R,
  ]
}

export const getWarehouseDocumentIncomeTypes = () => {
  return [
    WAREHOUSE_DOCUMENT_TYPE_PZ,
    WAREHOUSE_DOCUMENT_TYPE_PW,
    WAREHOUSE_DOCUMENT_TYPE_ZWZ,
  ]
}

export const getWarehouseDocumentOutcomeTypes = () => {
  return [
    WAREHOUSE_DOCUMENT_TYPE_WZ,
    WAREHOUSE_DOCUMENT_TYPE_RW,
    WAREHOUSE_DOCUMENT_TYPE_ZPZ,
  ]
}

export const getWarehouseDocumentExternalTypes = () => {
  return [
    WAREHOUSE_DOCUMENT_TYPE_WZ,
    WAREHOUSE_DOCUMENT_TYPE_ZWZ,
    WAREHOUSE_DOCUMENT_TYPE_PZ,
    WAREHOUSE_DOCUMENT_TYPE_ZPZ,
  ]
}

export const getWarehouseDocumentInternalTypes = () => {
  return [
    WAREHOUSE_DOCUMENT_TYPE_RW,
    WAREHOUSE_DOCUMENT_TYPE_PW,
  ]
}

export const getSaleDocumentTypes = () => {
  return [
    SALE_DOCUMENT_TYPE_INVOICE,
    SALE_DOCUMENT_TYPE_VAT_MARGIN,
    SALE_DOCUMENT_TYPE_RECEIPT_FISCAL,
    SALE_DOCUMENT_TYPE_CORRECTION_INVOICE,
    SALE_DOCUMENT_TYPE_CORRECTION_RECEIPT_FISCAL,
    SALE_DOCUMENT_TYPE_ADVANCE_INVOICE,
    SALE_DOCUMENT_TYPE_FINAL_INVOICE,
  ]
}

export const getSaleDocumentCorrectionTypes = () => {
  return [
    SALE_DOCUMENT_TYPE_CORRECTION_INVOICE,
    SALE_DOCUMENT_TYPE_CORRECTION_RECEIPT_FISCAL,
  ]
}

export const getStorageDocumentTypes = () => ([
    STORAGE_DEFAULT_DOCUMENT_TYPE,
    STORAGE_TIRE_DOCUMENT_TYPE,
    STORAGE_SCOOTER_DOCUMENT_TYPE,
  ]
)

export const getStorageDocumentTypeUrlByType = (storageDocumentType) => {
  switch (storageDocumentType) {
    case STORAGE_DEFAULT_DOCUMENT_TYPE: return STORAGE_DEFAULT_DOCUMENT_TYPE_NAME;
    case STORAGE_TIRE_DOCUMENT_TYPE: return STORAGE_TIRE_DOCUMENT_TYPE_NAME;
    case STORAGE_SCOOTER_DOCUMENT_TYPE: return STORAGE_SCOOTER_DOCUMENT_TYPE_NAME;

  }
}

export default (type) => i18n.t(`common:document_type.${type}`)